<template>
  <div class="home" :class="[colorTheme]">
    <v-app id="inspire">
      <NavDrawer/>
      <AppBar/>
      <AddItemToCart/>
      <Footer/>
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src


import NavDrawer from '@/components/NavDrawer.vue'
import AppBar from '@/components/AppBar.vue'
import Footer from '@/components/Footer.vue'
import AddItemToCart from '@/components/AddItemToCart.vue'

export default {

  components: {
    NavDrawer,
    AppBar,
    AddItemToCart,
    Footer
  },
  data: () => ({
    drawer: null
  }),
  computed:{
    colorTheme: function () {
      return this.$store.state.shop.color_theme;
    },
  }
}
</script>
